import QRCode from "react-qr-code";

import { ColumnModal } from "@/components";
import { useAppProperties } from "@/hooks";
import { useTranslate } from "@/providers/context";
import { Collection, Video } from "@/api";
import { ITEM_TYPE_VIDEO } from "@/const";

export const AppCTAModal = ({
  open,
  setOpen,
  item,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  item: Collection | Video | undefined;
}) => {
  const { translate } = useTranslate();
  const { data: properties } = useAppProperties();
  const appName = properties?.AppleTitle ?? "";
  const deepLinkDomain = properties?.DeepLinkingDefaultLinkDomain;

  const itemId = !item
    ? undefined
    : item.Type === ITEM_TYPE_VIDEO
      ? (item as Video).VideoId
      : (item as Collection).TabId;
  const suffix = item && itemId ? `app?$type=${item.Type}&$id=${itemId}` : "";

  const deepLinkUrl = deepLinkDomain
    ? `https://${deepLinkDomain}/${suffix}`
    : undefined;

  const title = translate("This content is only available in our mobile app");

  return (
    <ColumnModal
      cols={3}
      title={!deepLinkUrl ? title : undefined}
      primaryText={translate("Okay")}
      align={deepLinkUrl ? "full" : "right"}
      secondaryText={translate("Close")}
      onOpenChange={setOpen}
      onConfirm={() => setOpen(false)}
      hideClose={!!deepLinkUrl}
      hideTrigger
      open={open}
    >
      {deepLinkUrl ? (
        <div className="text-item-primary p-8 pt-2 text-center">
          <div className="h4-bold mb-3">{title}</div>
          <div className="p1-regular">
            {translate(
              "Scan the QR code with your phone's camera to download the app and access this content.",
            )}
          </div>
          <div className="border-border mx-auto mb-4 mt-[48px] flex w-fit items-center justify-center rounded-lg border p-3">
            <QRCode size={196} value={deepLinkUrl} />
          </div>
        </div>
      ) : (
        <div className="p1-regular text-item-primary my-6 px-6">
          {translate("Download the")} {appName}{" "}
          {translate(
            "app from the Google Play or Apple App Store to access it.",
          )}
        </div>
      )}
    </ColumnModal>
  );
};
